import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import MembershipApplication from './components/MembershipApplication';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
    <Services />
    <MembershipApplication />
    <About />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
